import { render, staticRenderFns } from "./ProcessContrac.vue?vue&type=template&id=8bf12bd6&scoped=true"
import script from "./ProcessContrac.vue?vue&type=script&lang=js"
export * from "./ProcessContrac.vue?vue&type=script&lang=js"
import style0 from "./ProcessContrac.vue?vue&type=style&index=0&id=8bf12bd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf12bd6",
  null
  
)

export default component.exports